// src/components/FormSettings/FormSubmitSettings/FormSubmitSettingsPreviews.jsx
import React from 'react';
import DisplayCardPreview from './DisplayCardPreview';
//import RedirectPreview from './RedirectPreview'; // Hypothetical example
//import SendEmailPreview from './SendEmailPreview'; // Hypothetical example
//import DisplayToastPreview from './DisplayToastPreview'; // Hypothetical example
import DisplayTablePreview from './DisplayTablePreview'; // Hypothetical example

const FormSubmitSettingsPreviews = ({ selectedAction }) => {
  switch (selectedAction) {
    case 'displayInCard':
      return <DisplayCardPreview />;
//    case 'redirect':
//      return <RedirectPreview />;
//    case 'sendEmail':
//      return <SendEmailPreview />;
//    case 'displayToast':
//      return <DisplayToastPreview />;
    case 'addToSubmissionsTable':
      return <DisplayTablePreview />;
    default:
      return null;
  }
};

export default FormSubmitSettingsPreviews;
